import {StreamProgress as StreamProgressType} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/stream_progress.types';
import {Slot, StreamProgress, tabletAndUp} from '@aboutyou/ui-components';
import React, {FC} from 'react';
import styled, {css} from 'styled-components';
import {NonProductTileSpacingAdjustment} from '../helpers';

type Props = {
  gridColumns: number | undefined;
  streamPosition: number;
  tile: StreamProgressType;
};

export const StreamProgressPositioned: FC<Props> = ({
  gridColumns,
  streamPosition,
  tile,
}) => {
  return (
    <StyledSlot columns={gridColumns} position={streamPosition} Comp="li">
      <StreamProgressBar
        count={tile.progressCount}
        label={tile.label}
        total={tile.totalCount}
      />
    </StyledSlot>
  );
};

const StyledSlot = styled(Slot)`
  /*
    Workaround for overlapping progress bar.
    The progress bar may be positioned in the same row as other elements,
    for example story recos. In that case the progress bar is supposed
    to be hidden below the other element.
  */
  z-index: -1;

  ${NonProductTileSpacingAdjustment}
`;

const StreamProgressBar = styled(StreamProgress)`
  ${tabletAndUp(css`
    margin: 1.5rem 0 2rem;
  `)}
`;
